import * as wixappsCore from './aspects/wixappsCore/wixappsCore'
import * as wixappsClassics from './aspects/wixappsClassics/wixappsClassics'

export const runtime = {
    wixappsCore,
    wixappsClassics
}
